import { FC } from 'react'

import { getRouteApi } from '@tanstack/react-router'
import { PageSection } from 'ui/components/Page'
import { LicensingQuestionnaire } from '~bank-annual-review/components/LicensingQuestionnaire'

import { LicensesTable } from '../../../../../components/LicensesTable'

export const Licensing: FC = (): JSX.Element => {
  const data = getRouteApi('/_app/annual-review/detail/$companyId/$id').useLoaderData()

  return (
    <PageSection title="Licensing">
      <LicensesTable />
      <LicensingQuestionnaire data={data} />
    </PageSection>
  )
}
